<template>

    <div id="documentation">
        <div v-if="loaded">
            <div v-if="docs.error === false" v-html="docs.content" id="documentation-content"></div>
            <div class="w-full lg:w-2/3 mx-auto my-64" v-else>
                <div class="flex items-center h-full text-center">
                    <div class="flex text-brand-500 p-8">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" preserveAspectRatio="none" class="fill-current w-32 h-32 flex-shrink-0">
                            <path d="M476.791 135.986L250.075 5.818 50.9 120.812l425.765 245.379V283.2l-288.49-165.674 58.07-33.522 230.546 132.357zm-453.582.492l423.717 244.204-196.635 113.499L23.578 363.287v-77.109l228.319 131.107 58.05-33.506L23.209 219.091z"></path>
                        </svg>
                    </div>
                    <div class="flex-1 text-brand-alt-500 text-left">
                        <h1 class="font-bold text-6xl mb-1">404</h1>
                        <h2 class="text-3xl">Not Found</h2>
                        <div class="flex my-4">
                            <p>
                                The requested document page could not be found, please check the URL.
                            </p>
                        </div>
                        <div class="flex mt-2">
                            <a href="#" @click.prevent="goBack">Go Back</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loading message="Loading Documentation" v-else></Loading>
    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {Documentation} from "../../app/Auth/Documentation";
import Prism from 'prismjs'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-liquid'
import 'prismjs/components/prism-markdown'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-http'
import {NavigationMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "Documentation",
    mixins: [PermissionMixin, NavigationMixin],
    data() {
        return {
            docs: null,
            loaded: false,
        }
    },
    components: {
        Loading
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.docs = new Documentation();

            let page = vm.$router.currentRoute.path.replace('/app/docs', '');

            vm.docs.loadDocumentation(page).then(result => {
                resolve(true);
            }).catch(error => vm.handleError(error));
        }).then(result => {
            vm.loaded = result;

            setTimeout(function () {
                Prism.highlightAll();
            }, 60);
        });
    }
}
</script>


